module.exports = __webpack_public_path__ + "img/01.85c53ac2.jpg";